
// services/paymentService.js
import { auth } from '../config/firebase';

// URL de l'API Cloud Run déployée
const API_BASE_URL = "https://apiv1-32dxg5qwva-uc.a.run.app";

/**
 * Crée un paiement d'abonnement
 * @param {Object} user - Données utilisateur
 * @param {Object} plan - Plan d'abonnement
 * @returns {Promise} Résultat du paiement
 */
export async function createSubscriptionPayment(user, plan) {
    // Validation des données
    if (!plan || typeof plan !== 'object') {
        throw new Error("Plan d'abonnement invalide");
    }

    if (!user || typeof user !== 'object') {
        throw new Error("Données utilisateur manquantes");
    }

    // Validation des champs requis
    if (!user.uid && !user.id) {
        throw new Error("UID utilisateur manquant");
    }

    if (!user.email) {
        throw new Error("Email utilisateur manquant");
    }

    try {
        // Vérifier que l'utilisateur est authentifié
        const currentUser = auth.currentUser;
        if (!currentUser) {
            throw new Error("Utilisateur non authentifié. Veuillez vous reconnecter.");
        }

        // S'assurer que l'ID token est valide
        const idToken = await currentUser.getIdToken(true);

        const payload = {
            plan,
            user: {
                uid: user.uid || user.id,
                email: user.email,
                name: user.name || user.displayName || 'Utilisateur'
            }
        };


        // Appel direct à l'API Cloud Run
        const response = await fetch(`${API_BASE_URL}/createSubscriptionPayment`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                // Ajouter le token d'authentification si nécessaire
                'Authorization': `Bearer ${idToken}`
            },
            body: JSON.stringify(payload)
        });


        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`Erreur ${response.status}: ${errorText}`);
        }

        const result = await response.json();

        if (!result.result || !result.result.success) {
            throw new Error(result.error?.message || result.result?.error || "Erreur lors de la création du paiement");
        }

        return result.result.paymentUrl;

    } catch (error) {
        throw new Error(error.message || "Erreur lors de la création du paiement");
    }
}

/**
 * Vérifie le statut d'un paiement
 * @param {string} transactionId - ID de la transaction
 * @returns {Promise} Statut du paiement
 */
export const verifyPaymentStatus = async (transactionId) => {
    if (!transactionId) {
        throw new Error("ID de transaction manquant");
    }

    const response = await fetch(`${API_BASE_URL}/verifyPaymentStatus`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify({ transactionId })
    });

    if (!response.ok) {
        throw new Error(`Erreur ${response.status}`);
    }

    const result = await response.json();
    return result.result || result.data;
};


/**
 * Vérifie l'abonnement d'un utilisateur
 * @returns {Promise} Données d'abonnement
 */
export const checkUserSubscription = async () => {
    const response = await fetch(`${API_BASE_URL}/checkUserSubscription`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        }
    });

    if (!response.ok) {
        throw new Error(`Erreur ${response.status}`);
    }

    const result = await response.json();
    return result.result || result.data;
};